module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tempUserNotifications) ? _c('div', [_c('uiv-modal', {
    attrs: {
      "size": "lg",
      "backdrop": false,
      "title": "Event User Notifications",
      "append-to-body": ""
    },
    on: {
      "hide": _vm.eventNotificationsDialogAccepted
    },
    model: {
      value: (_vm.showEventNotificationsDialog),
      callback: function($$v) {
        _vm.showEventNotificationsDialog = $$v
      },
      expression: "showEventNotificationsDialog"
    }
  }, [_c('event-notifications-editor-dialog', {
    model: {
      value: (_vm.tempUserNotifications),
      callback: function($$v) {
        _vm.tempUserNotifications = $$v
      },
      expression: "tempUserNotifications"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "iterationsEdit"
    }
  }, [_vm._v("Iterations")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.iterations),
      expression: "value.iterations"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "1000",
      "id": "iterationsEdit",
      "placeholder": "Enter maximum iterations",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.iterations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "iterations", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "resetGroup"
    }
  }, [_vm._v("Reset Type")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "resetGroup"
    }
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.resetType),
      expression: "value.resetType"
    }],
    attrs: {
      "type": "radio",
      "value": "None"
    },
    domProps: {
      "checked": _vm._q(_vm.value.resetType, "None")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value, "resetType", "None")
      }
    }
  }), _vm._v("None\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.resetType),
      expression: "value.resetType"
    }],
    attrs: {
      "type": "radio",
      "value": "Warm"
    },
    domProps: {
      "checked": _vm._q(_vm.value.resetType, "Warm")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value, "resetType", "Warm")
      }
    }
  }), _vm._v("Warm\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.resetType),
      expression: "value.resetType"
    }],
    attrs: {
      "type": "radio",
      "value": "Cold"
    },
    domProps: {
      "checked": _vm._q(_vm.value.resetType, "Cold")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value, "resetType", "Cold")
      }
    }
  }), _vm._v("Cold\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "resourceCurvePriceIncrementEdit"
    }
  }, [_vm._v("Resource Marginal Cost Increment")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.resourceCurvePriceIncrement),
      expression: "value.resourceCurvePriceIncrement"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "1",
      "id": "resourceCurvePriceIncrementEdit",
      "placeholder": "Enter marginal cost increment",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.resourceCurvePriceIncrement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "resourceCurvePriceIncrement", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "resourceCurveNumPointsEdit"
    }
  }, [_vm._v("Number of Resource Curve Points")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.resourceCurveNumPoints),
      expression: "value.resourceCurveNumPoints"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "10",
      "min": "10",
      "max": "200",
      "id": "resourceCurveNumPointsEdit",
      "placeholder": "Enter number of resource curve points",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.resourceCurveNumPoints)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "resourceCurveNumPoints", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "maxPriceEdit"
    }
  }, [_vm._v("Maximum Seed Price")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.maxPrice),
      expression: "value.maxPrice"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "10",
      "id": "maxPriceEdit",
      "placeholder": "Enter maximum seed price",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.maxPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "maxPrice", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "numCoresEdit"
    }
  }, [_vm._v("Maximum number of cores (-1: automatic)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.numCores),
      expression: "value.numCores"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "-1",
      "id": "numCoresEdit",
      "placeholder": "Enter maximum number of cores to use, or -1 for automatic",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.numCores)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "numCores", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.scenarioNamesSelection) ? _c('div', [_c('label', {
    attrs: {
      "for": "scenarioNamesSelect"
    }
  }, [_vm._v("Scenarios to Converge")]), _vm._v(" "), _c('div', [_c('uiv-multi-select', {
    attrs: {
      "stye": "width:100%",
      "options": _vm.scenarioNamesSelection,
      "label-key": "label",
      "label-value": "name",
      "id": "scenarioNamesSelect"
    },
    model: {
      value: (_vm.value.scenarioNamesToRun),
      callback: function($$v) {
        _vm.$set(_vm.value, "scenarioNamesToRun", $$v)
      },
      expression: "value.scenarioNamesToRun"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isValidating
    },
    on: {
      "click": _vm.onNotificationsClick
    }
  }, [_vm._v("\n                Notifications (" + _vm._s(_vm.value.userNotifications.filter(function (it) { return it.enabled; }).length) + ")\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.modelNamesSelection && _vm.value.modelNamesToRun) ? _c('div', [_c('label', {
    attrs: {
      "for": "modelNamesSelect"
    }
  }, [_vm._v("Models (integrated mode)")]), _vm._v(" "), _c('div', [_c('uiv-multi-select', {
    attrs: {
      "disabled": _vm.modelNamesSelection.length < 2,
      "stye": "width:100%",
      "options": _vm.modelNamesSelection,
      "label-key": "label",
      "label-value": "name",
      "id": "modelNamesSelect"
    },
    model: {
      value: (_vm.value.modelNamesToRun),
      callback: function($$v) {
        _vm.$set(_vm.value, "modelNamesToRun", $$v)
      },
      expression: "value.modelNamesToRun"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    attrs: {
      "for": "skipValidationCb"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.skipValidation),
      expression: "value.skipValidation"
    }],
    attrs: {
      "type": "checkbox",
      "id": "skipValidationCb"
    },
    domProps: {
      "checked": Array.isArray(_vm.value.skipValidation) ? _vm._i(_vm.value.skipValidation, null) > -1 : (_vm.value.skipValidation)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.skipValidation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value, "skipValidation", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value, "skipValidation", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value, "skipValidation", $$c)
        }
      }
    }
  }), _vm._v("\n                    Skip model validation\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    attrs: {
      "for": "logConvergenceRunStats"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.logConvergenceRunStats),
      expression: "value.logConvergenceRunStats"
    }],
    attrs: {
      "type": "checkbox",
      "id": "logConvergenceRunStats"
    },
    domProps: {
      "checked": Array.isArray(_vm.value.logConvergenceRunStats) ? _vm._i(_vm.value.logConvergenceRunStats, null) > -1 : (_vm.value.logConvergenceRunStats)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.logConvergenceRunStats,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value, "logConvergenceRunStats", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value, "logConvergenceRunStats", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value, "logConvergenceRunStats", $$c)
        }
      }
    }
  }), _vm._v("\n                    Log overall convergence run statistics\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    attrs: {
      "for": "logConvergenceStats"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.logConvergenceStats),
      expression: "value.logConvergenceStats"
    }],
    attrs: {
      "type": "checkbox",
      "id": "logConvergenceStats"
    },
    domProps: {
      "checked": Array.isArray(_vm.value.logConvergenceStats) ? _vm._i(_vm.value.logConvergenceStats, null) > -1 : (_vm.value.logConvergenceStats)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.logConvergenceStats,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value, "logConvergenceStats", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value, "logConvergenceStats", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value, "logConvergenceStats", $$c)
        }
      }
    }
  }), _vm._v("\n                    Log per-node convergence statistics\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    attrs: {
      "for": "dryRunCb"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.dryRun),
      expression: "value.dryRun"
    }],
    attrs: {
      "type": "checkbox",
      "id": "dryRunCb"
    },
    domProps: {
      "checked": Array.isArray(_vm.value.dryRun) ? _vm._i(_vm.value.dryRun, null) > -1 : (_vm.value.dryRun)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.dryRun,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value, "dryRun", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value, "dryRun", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value, "dryRun", $$c)
        }
      }
    }
  }), _vm._v("\n                    Dry run (results of convergence will not be saved)\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "commentsEdit"
    }
  }, [_vm._v("Comments")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.comments),
      expression: "value.comments"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "commentsEdit",
      "placeholder": "Enter comments (optional)",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.value.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "comments", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isValidating
    },
    on: {
      "click": _vm.onConvergeClick
    }
  }, [_vm._v("Converge")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isValidating
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v("Cancel")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d0e1af8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d0e1af8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/converge-model-dialog/converge-model-dialog.vue.html
// module id = 1121
// module chunks = 0